'use client';

import dynamic from 'next/dynamic';

// A client module, so each block is a chunk fetched only when rendered: dynamic() in a server
// component still lists every target as a page entry script. Server blocks stay static in
// Content, so their heavy client parts need their own split (DemoProduct/LazyClient, Contact)
export const HeroCTASection = dynamic(() =>
  import('@/blocks/HeroCTASection').then((m) => m.HeroCTASection),
);
export const ItemsGrid = dynamic(() => import('@/blocks/ItemsGrid').then((m) => m.ItemsGrid));
export const ImageWithAccordion = dynamic(() =>
  import('@/blocks/ImageWithAccordion').then((m) => m.ImageWithAccordion),
);
export const CalendlyBookingWidget = dynamic(() =>
  import('@/blocks/CalendlyBookingWidget').then((m) => m.CalendlyBookingWidget),
);
export const ProductHeaderWidget = dynamic(() =>
  import('@/blocks/ProductHeaderWidget').then((m) => m.ProductHeaderWidget),
);
export const ProductExampleImages = dynamic(() =>
  import('@/blocks/ProductExampleImages').then((m) => m.ProductExampleImages),
);
export const FAQ = dynamic(() => import('@/blocks/FAQ').then((m) => m.FAQ));
export const ImageWithDescription = dynamic(() =>
  import('@/blocks/ImageWithDescription').then((m) => m.ImageWithDescription),
);
export const FAQLarge = dynamic(() => import('@/blocks/FAQLarge').then((m) => m.FAQLarge));
export const InsightsAndWebinars = dynamic(() =>
  import('@/blocks/InsightsAndWebinars').then((m) => m.InsightsAndWebinars),
);
export const Webinar = dynamic(() =>
  import('@/blocks/InsightsAndWebinars/Webinar').then((m) => m.Webinar),
);
export const LearnMore = dynamic(() => import('@/blocks/InsightsAndWebinars/LearnMore'));
export const Quote = dynamic(() => import('@/blocks/Quote').then((m) => m.Quote));
export const PhotoGrid = dynamic(() => import('@/blocks/PhotoGrid'));
export const UsefulDocuments = dynamic(() =>
  import('@/blocks/UsefulDocuments').then((m) => m.UsefulDocuments),
);
export const CTAButton = dynamic(() => import('@/blocks/CTAButton').then((m) => m.CTAButton));
export const ImageWithAccordionScroll = dynamic(() =>
  import('@/blocks/ImageWithAccordionScroll').then((m) => m.ImageWithAccordionScroll),
);
